/**
 * VERA 404 Not Found Page
 */
import React from "react";
import { useNavigate } from "react-router-dom";
import {
  makeStyles,
  Text,
  Button,
  Card,
} from "@fluentui/react-components";
import { Warning24Regular, Home24Regular } from "@fluentui/react-icons";

const useStyles = makeStyles({
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    padding: "20px",
  },
  card: {
    textAlign: "center",
    padding: "60px 48px",
    maxWidth: "480px",
    borderRadius: "16px",
    border: "1px solid #e2e8f0",
  },
  icon: {
    fontSize: "48px",
    color: "#63666A",
    marginBottom: "16px",
  },
  title: {
    fontFamily: "'Poppins', sans-serif",
    color: "#2D2926",
    marginBottom: "8px",
  },
  description: {
    color: "#63666A",
    marginBottom: "24px",
  },
});

export const NotFoundPage: React.FC = () => {
  const styles = useStyles();
  const navigate = useNavigate();

  return (
    <div className={styles.container}>
      <Card className={styles.card}>
        <div className={styles.icon}>
          <Warning24Regular />
        </div>
        <Text size={800} weight="semibold" className={styles.title} block>
          Page Not Found
        </Text>
        <Text size={400} className={styles.description} block>
          The page you're looking for doesn't exist or has been moved.
        </Text>
        <Button
          appearance="primary"
          icon={<Home24Regular />}
          onClick={() => navigate("/")}
          size="large"
        >
          Return to Dashboard
        </Button>
      </Card>
    </div>
  );
};

export default NotFoundPage;
